<template>
  <div
      class="btn-group"
      role="group"
      v-if="showComponent && !enableFloating && hasSlotOptions"
      :key="`btn-group-${componentRefresh}`"
  >
    <button
        type="button"
        :disabled="!enableComponent || disabled"
        :class="['btn', cColor, cSize, classes]"
        @click.prevent="multiClickPrevent"
    >
      <slot/>
      <template
          v-if="!hasSlotDefault"
      >
        <i
            :class="[classIcon]"
            v-if="classIcon"
        />
        <ks-space v-if="classIcon && label"/>
        {{ label }}
      </template>
    </button>
    <div
        class="btn-group"
    >
      <button
          type="button"
          :disabled="!enableComponent || disabled"
          :class="['btn', cColor, cSize, classes, 'dropdown-toggle']"
          :id="`ks-dmb-${_uid}`"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      </button>
      <div
          class="dropdown-menu"
          :aria-labelledby="`ks-dmb-${_uid}`"
      >
        <slot
            name="options"
        />
      </div>
    </div>
  </div>

  <button
      type="button"
      :key="`btn-${componentRefresh}`"
      :disabled="!enableComponent || disabled"
      :class="['btn', cColor, cSize, classes]"
      @click.prevent="multiClickPrevent"
      v-else-if="showComponent && !enableFloating"
  >
    <slot/>
    <template
        v-if="!hasSlotDefault"
    >
      <i
          :class="[classIcon]"
          v-if="classIcon && !iconAfter"
      />
      <ks-space
          v-if="classIcon && label && space"
      />
      {{ label }}
      <ks-space
          v-if="classIcon && label && space"
      />
      <i
          :class="[classIcon]"
          v-if="classIcon && iconAfter"
      />
    </template>
  </button>
  <a
      type="button"
      :key="`btn-float-${componentRefresh}`"
      :disabled="!enableComponent || disabled"
      :class="['float-button', cColor, classes]"
      @click.prevent="multiClickPrevent"
      v-else-if="showComponent && enableFloating"
  >
    <slot/>
    <template
        v-if="!hasSlotDefault"
    >
      <i
          :class="[`${classIcon} float-button-icon`]"
          v-if="classIcon"
      />
    </template>
  </a>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

var timeout = null;
export default {
  name:     "ks-button",
  mixins:   [checkPermissions],
  props:    {
    disabled:             {type: Boolean, default: false},
    space:                {type: Boolean, default: true},
    iconAfter:            {type: Boolean, default: false},
    label:                {type: String, default: null},
    classIcon:            {type: String, default: null},
    classes:              {type: String, default: null},
    size:                 {type: String, default: null}, //sm-lg-md
    color:                {type: String, default: null},
    showFloatingInMobile: {type: Boolean, default: false},
    push:                 {default: null},
    doubleClickPrevent:   {type: Boolean, default: false}
  },
  methods:  {
    multiClickPrevent(evt) {
      if (this.doubleClickPrevent) {
        if (timeout) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
          this.onClick(evt);
        }, 900);
      } else {
        this.onClick(evt);
      }
    },
    onClick(params) {
      if (this.push) {
        let redirect = typeof this.push == 'object' ? this.push : {path: this.push};
        this.$router.push(redirect);
        this.$emit('onPush', {event: params, push: this.push});
      } else {
        this.$emit('onClick', params);
      }

    }
  },
  computed: {
    enableFloating() {
      return this.showFloatingInMobile && app.layout.screenSizeId < 3;
    },
    cSize() {
      return this.size ? `btn-${this.size}` : '';
    },
    cColor() {
      return this.color ? `${!this.enableFloating ? 'btn' : 'bg'}-${this.color}` : `${!this.enableFloating ? 'btn' : 'bg'}-primary`;
    },
    hasSlotOptions() {
      return !!this.$slots.options;
    },
    hasSlotDefault() {
      return !!this.$slots.default;
    }
  }
}
</script>
